/* FJBC item-reference search. Shopify's search page does not match an inventory number, but its
   predictive search API does once variants.sku is asked for. A query shaped like an item reference
   (R-1359, r1359, R 1359, PRL-328N) is normalised to the dashed upper-case form and looked up
   there; one exact match goes straight to the item. Everything else searches as it always did. */
(function () {
  var SKU = /^([A-Za-z]{1,4})\s*-?\s*(\d{1,5})\s*([A-Za-z]{1,2})?$/;
  var TIMEOUT = 2500;

  function normalise(value) {
    var match = SKU.exec(String(value == null ? '' : value).trim());
    return match ? (match[1] + '-' + match[2] + (match[3] || '')).toUpperCase() : null;
  }

  function json(url, signal) {
    return fetch(url, { signal: signal, headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error(String(response.status));
      return response.json();
    });
  }

  /* The predictive response carries no SKU of its own (its `variants` array is empty on
     single-variant products) and it matches on a prefix, so B-79 comes back as B-799. Each
     candidate's own variants are read and compared exactly. */
  function matchesFor(form, sku, signal) {
    var action = ((form && form.getAttribute('action')) || '/search').replace(/\/+$/, '');
    var url = action + '/suggest.json?q=' + encodeURIComponent(sku) +
      '&resources[type]=product&resources[limit]=10&resources[options][fields]=variants.sku';
    return json(url, signal).then(function (data) {
      var found = ((((data || {}).resources || {}).results || {}).products) || [];
      return Promise.all(found.map(function (product) {
        var path = String(product.url || '').split('?')[0];
        return json(path + '.js', signal).then(function (full) {
          var hit = ((full || {}).variants || []).filter(function (variant) {
            return String(variant.sku || '').toUpperCase() === sku;
          })[0];
          if (!hit) return null;
          product.sku = hit.sku;
          return product;
        }).catch(function () { return null; });
      }));
    }).then(function (list) {
      return list.filter(Boolean);
    });
  }

  /* Never hold a submit for longer than TIMEOUT: on abort or error the answer is "no match". */
  function lookup(form, sku) {
    var controller = window.AbortController ? new AbortController() : null;
    var expiry = new Promise(function (resolve) {
      window.setTimeout(function () {
        if (controller) controller.abort();
        resolve([]);
      }, TIMEOUT);
    });
    var work = matchesFor(form, sku, controller && controller.signal).catch(function () { return []; });
    return Promise.race([work, expiry]);
  }

  function onSubmit(event) {
    var form = event.currentTarget;
    var field = form.querySelector('input[name="q"]');
    if (!field) return;
    if (form.dataset.skuBusy) { event.preventDefault(); return; }
    var sku = normalise(field.value);
    if (!sku) return;
    field.value = sku;
    event.preventDefault();
    form.dataset.skuBusy = 'true';
    lookup(form, sku).then(function (matches) {
      if (matches.length === 1) { window.location.assign(matches[0].url); return; }
      delete form.dataset.skuBusy;
      form.submit();
    });
  }

  function card(product) {
    var item = document.createElement('div');
    item.className = 'ptile-wrap';
    item.innerHTML = '<a class="ptile" tabindex="-1"></a><a class="pcard-name"></a><div class="pcard-spec"></div>';
    var media = item.querySelector('.ptile');
    var name = item.querySelector('.pcard-name');
    media.href = product.url;
    name.href = product.url;
    name.textContent = product.title;
    item.querySelector('.pcard-spec').textContent = 'Item reference: ' + product.sku;
    var picture = product.featured_image || {};
    if (picture.url) {
      var image = new Image();
      image.src = picture.url + (picture.url.indexOf('?') === -1 ? '?' : '&') + 'width=400';
      image.alt = picture.alt || product.title;
      image.loading = 'lazy';
      media.appendChild(image);
    }
    return item;
  }

  function fillFallback() {
    var target = document.querySelector('[data-sku-fallback]');
    if (!target) return;
    var sku = normalise(target.getAttribute('data-sku-fallback'));
    if (!sku) return;
    lookup(document.querySelector('form[role="search"]'), sku).then(function (matches) {
      if (!matches.length) return;
      var grid = document.createElement('div');
      grid.className = 'sh-grid';
      matches.forEach(function (product) { grid.appendChild(card(product)); });
      target.appendChild(grid);
      var empty = document.querySelector('.sr-empty');
      if (empty) empty.hidden = true;
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('form[role="search"]'), function (form) {
      form.addEventListener('submit', onSubmit);
    });
    fillFallback();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
